<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <span v-show="$store.getters['app/overlays'].show_start_menu_overlay">
      <img draggable="false" class="background_image" src="./assets/ossodresiosso/images/Asset 49.png" alt="">

      <span v-show="selected_text >= 0">
        <div class="intro_drawer"></div>
        <span v-if="selected_text == 0" id="game_text">Osso Dresi Osso</span>
          <span v-html="texts[selected_text]" id="game_intro_text" :style="selected_text > 0 ? 'margin-top: 7%;' : ''"></span>
          <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./assets/ossodresiosso/images/Asset 51_.png" alt="">
          <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./assets/ossodresiosso/images/Asset 51_.png" alt="">
          <img draggable="false" class="clickable" @click="showStartMenu()" id="start_btn" src="./assets/ossodresiosso/images/Asset 30.png" alt="">
      </span>

      <span v-show="selected_text == -1">
        <img draggable="false" class="clickable" @click="goToStartPage()" id="begin_btn" src="./assets/ossodresiosso/images/Asset 57_.png" alt="">
        <img draggable="false" id="logo" src="./assets/ossodresiosso/images/Asset 48.png" alt="">
        <img draggable="false" class="clickable" id="quit_btn" @click="showIntro()" src="./assets/ossodresiosso/images/Asset 29.png" alt="">
      </span>
    </span>
    
    <router-view/>
  </div>

</template>

<script>

export default {
  name: 'App',

  mounted() {
    this.checkLandscape()
  },

  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {
      selected_text: 0,
      texts: [
        "Wisten jullie dat er in het geheimzinnige bos en zelfs om ons heen planten zijn die net als artsen zieken kunnen genezen? Ja, dat klopt! Deze planten kunnen je beter maken als je ze inneemt, er thee van maakt of zelfs over je huid wrijft. Soms moeten deze planten samenwerken als een team om hun magische krachten te onthullen. Lees verder en ontdek 32 planten die samenwerken om wonderen te verrichten! <br><br> Ben je klaar om in de voetsporen te treden van de oude geneesmeesters en je eigen magische Oso Dresi te maken? Laten we beginnen! Zoek naar vier speciale planten je kunt combineren die bij de juiste combinatie een specifieke ziekte genezen",

        "Nu ben je klaar om de wereld te genezen! Deel je Oso Dresi met vrienden en familie die zich niet lekker voelen. Laat ze zien dat jij een echte geneesmeester bent geworden, en wie weet, kun je wel een glimlach toveren op hun gezicht. <br><br> Ga naar de volgende pagina voor de <u>8 Osso Dresi Osso kwartetten</u>",

        "1. Diarree: RODE LOKUS - MAHONIE - KRUBARA - CACAO <br><br> 2. Koorts: KUSUWÉ - KREREKRERE - BATOTOBITA - PODOSIRI <br><br> 3. Maagklachten / Buikpijn: RODE LOKUS - KANKANTRIE - MOPE - REDI KATUN <br><br> 4. Open wonden, schaaf- en snijwonden: KRUBARA - UMA BUSIPAPAYA - KOFIMAMA - WALABA <br><br> 5. Verkoudheid: LEGUANA OKRO - KUNAME of WILDE NEKU - BLAKA UMA - KREREKRERE <br><br> 6. Hoesten: GROENHART - LEGUANA OKRO - LAAGLAND BABUN - KANKANTRIE <br><br> 7. Spierpijn: DOIFISIRI - RODE LOKUS - UMA BUSIPAPAYA - KUSUWÉ",

        "8. Tandvlees/mondhygiëne: LAAGLAND BABUN - KAKA (FOWRU) KANKAN - KUSUWÉ - KREREKRERE"
      ]
    };
  },

  methods: {
    goToStartPage() {
      this.$router.push('/start');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },

    showStartMenu() {
      this.selected_text = -1
    },

    showIntro() {
      this.selected_text = 0
    },

    nextText() {
      this.selected_text++;
    },

    prevText() {
      this.selected_text--;
    },

    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},

  watch: {}
}
</script>

<style>
  .landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }

  @font-face {
    font-family: "LuckiestGuy";
    src: url('./assets/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  #game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 50%;
    left: 25%;
    color: white;
    font-size: 4vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }

  #game_intro_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 10.5%;
    width: 70%;
    left: 15%;
    color: white;
    font-size: 2vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }

  .background_image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

  body {
    cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
  }

  #start_btn {
    position: absolute;
    margin-top: 43%;
    left: 43%;
    width: 15%;
  }
  #begin_btn {
    position: absolute;
    margin-top: 25%;
    left: 27%;
    width: 21%;
  }

  .clickable:hover {
    opacity: 0.7;
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
  }

  #quit_btn {
    position: absolute;
    margin-top: 25%;
    left: 51%;
    width: 21%;
  }

  #logo {
    position: absolute;
    margin-top: 7%;
    left: 27%;
    width: 45%;
  }

  body {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  #next_btn {
    position: absolute;
    margin-top: 44%;
    left: 73%;
    width: 5%;
  }
  #prev_btn {
    transform: rotate(180deg);
    position: absolute;
    margin-top: 44%;
    left: 20%;
    width: 5%;
  }
  .intro_drawer {
    /* z-index: 1; */
    width: 95%;
    height: 95%;
    position: fixed;
    margin-top: 1%;
    left: 2.5%;
    /* From https://css.glass */
    background: rgba(255, 255, 255, 0.27);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5.8px);
    -webkit-backdrop-filter: blur(5.8px);
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  .z_index {
    z-index: 2;
  }

</style>
